import axios from "axios";
import { idText } from "typescript";
import toast from "react-hot-toast";
import { getToken, getUser, toastStyle } from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2, putAPICall, deleteAPICall, getWithParamsAPICall } from "./axiosMethodCalls";


export const getShowDiscounts = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "discounts/show/" + id
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};
export const getAllDiscounts = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "discounts/getAll"
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const createDiscount = async (data, selected) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "discounts/create", {
                requester: getUser(),
                token: getToken(),
                name: data.name,
                percentage: data.percentage,
                amount: data.amount,
                use_net_for_discount: data.use_net_for_discount,
                open_discount_amount: data.open_discount_amount,
                item_discount: data.item_discount,
                print_approval_copy: data.print_approval_copy,
                open_discount_rate: data.open_discount_rate,
                ref_no: data.ref_no,
                ref_name: data.ref_name,
                suspend_discount: data.suspend_discount,
                is_vat_exempt: data.is_vat_exempt,
                is_percentage: data.is_percentage,
                menu_ids: selected.map((item) => {
                    return item.id;
                }),
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateDiscount = async (data) => {
    try {
        const params = new URLSearchParams()
        params.append('name',data.name)
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('percentage',data.percentage)
        params.append('amount',data.amount)
        params.append('is_percentage',data.is_percentage)
        params.append("use_net_for_discount", data.use_net_for_discount)
        params.append("open_discount_amount", data.open_discount_amount)
        params.append("item_discount", data.item_discount)
        params.append("print_approval_copy", data.print_approval_copy)
        params.append("open_discount_rate", data.open_discount_rate)
        params.append("ref_no", data.ref_no)
        params.append("ref_name", data.ref_name)
        params.append("suspend_discount", data.suspend_discount)
        params.append("is_vat_exempt", data.is_vat_exempt)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "discounts/update/" + data.id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//SEARCH
export const searchDiscounts = async (name) => {
    try {
        const response = await getWithParamsAPICall(process.env.REACT_APP_LINK + 'discounts/search', {
            requester: getUser(),
            token: getToken(),
            term: name,
        });
        return ({ data: response });
    } catch (error) {
        if (error.response.status === 401) {
          toast.error(
            "Unauthorized access: another device is using this account", {style: toastStyle(),}
          );
        //   removeSession();

        }
        return ({ error: error.response });
    }
}

//GET
export const deleteDiscount = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "discounts/delete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};